import { CallToAction, CallToActionType, PageModule, PageModuleType } from '../../../types/working-model';

// Re-export default component so bare-path imports of this module still find NavItem
export { default } from './nav-item.tsx';

export function checkLinkedSectionIsOn(navItem: CallToAction, activePageModules: { type: PageModuleType; id: number; }[]): boolean {
	if (navItem.type === CallToActionType.section && navItem.content.section) {
		return activePageModules.some(pm => pm.type === navItem.content.section);
	}
	if (navItem.type === CallToActionType.section && navItem.content.section_module_id) {
		return activePageModules.some(pm => pm.id === navItem.content.section_module_id);
	}
	return true;
}

export function filterActiveModules(modules?: PageModule[]): { type: PageModuleType; id: number; }[] {
	return modules?.filter(m => m.is_on).map(m => ({ type: m.type, id: m?.id || 0 })) || [];
}
